import { render } from "./Button_variants.vue?vue&type=template&id=84fb3d6c"
import script from "./Button_variants.vue?vue&type=script&lang=js"
export * from "./Button_variants.vue?vue&type=script&lang=js"

import "./Button_variants.vue?vue&type=style&index=0&id=84fb3d6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__